import React from 'react';
import { i18n as I18n } from '../utils/i18n';

// components
import RoomsPage from '../components/roomsPage';

const BookMeetingRoomsPage = () => {
  return (
    <RoomsPage
      roomType="meeting"
      title={I18n.t('room_types_landing_page.meeting.title')}
      roomCategory={I18n.t('shared.non_clinical').toLowerCase()}
      headerTitle={I18n.t('headers.meeting_rooms.title')}
      headerDescription={I18n.t('headers.meeting_rooms.description')}
    />
  );
};

export default BookMeetingRoomsPage;
